import React, { useEffect, useState } from 'react';
import ReactECharts from 'echarts-for-react';

export interface ChartData {
  name: string;
  budget: number;
  actual: number;
  fill?: string;
}

interface BudgetReportChartProps {
  lineItemChartData: ChartData[];
}

const BudgetReportChart: React.FC<BudgetReportChartProps> = ({
  lineItemChartData,
}) => {
  const [option, setOption] = useState<any>({
    textStyle: {
      fontFamily: 'proxima-nova, sans-serif',
    },
    legend: {},
    grid: {
      top: 32,
      right: 0,
      bottom: 8,
      left: 4,
      containLabel: true,
    },
    tooltip: {
      trigger: 'item',
      axisPointer: { type: 'cross' },
    },
    dataset: {
      source: [],
    },
    xAxis: {
      type: 'category',
      axisTick: {
        alignWithLabel: true,
      },
      axisLabel: {
        interval: 0,
        hideOverlap: false,
        formatter: (value: string) => value,
        overflow: 'truncate',
      },
    },
    yAxis: {
      type: 'value',
    },
    series: [
      {
        type: 'bar',
        barCategoryGap: 16,
        barWidth: lineItemChartData.length > 10 ? 24 : null,
        itemStyle: {
          color: '#327569', // Change bar color
        },
      },
      {
        type: 'bar',
        barCategoryGap: 16,
        barWidth: lineItemChartData.length > 10 ? 24 : null,
        itemStyle: {
          color: '#5A73B0', // Change bar color
        },
      },
    ],
  });

  useEffect(() => {
    const maxChars =
      lineItemChartData.length > 10
        ? 12
        : lineItemChartData.length >= 6
        ? 15
        : 20;

    // Prepare the dataset source
    const source: any[] = [['Budget', 'Allocation', 'Actual']];
    lineItemChartData.forEach((chartData) => {
      source.push([
        chartData.name,
        chartData.budget.toFixed(2),
        chartData.actual.toFixed(2),
      ]);
    });

    // Update the option state
    setOption((prev: any) => ({
      ...prev,
      xAxis: {
        ...prev.xAxis,
        axisLabel: {
          ...prev.xAxis.axisLabel,
          formatter: (value: string) => {
            return value.length > maxChars
              ? value.substring(0, maxChars) + '...'
              : value;
          },
        },
      },
      series: prev.series.map((s: any) => ({
        ...s,
        barWidth: lineItemChartData.length > 10 ? 24 : null,
      })),
      dataset: {
        ...prev.dataset,
        source,
      },
    }));
  }, [lineItemChartData]);
  return (
    <div className='w-full flex-grow overflow-x-auto layout-cell'>
      <ReactECharts
        opts={{ renderer: 'svg' }}
        option={option}
        style={{
          width:
            lineItemChartData.length > 10
              ? lineItemChartData.length * 96
              : 'auto',
        }}
        lazyUpdate={true}
      />
    </div>
  );
};

export default BudgetReportChart;
